<div
  [class]="classes"
  [style.text-align]="widget.textAlign || 'left'"
  [innerHTML]="widget.text"
></div>
